module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parcours-single"
  }, [_c('loader'), _vm._v(" "), (_vm.epigramLoaded) ? _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "page-title-container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.versionLanguage(_vm.parcours.versions).title))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-md-offset-1"
  }, [_c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'parcoursIndex',
        params: {
          parcoursId: _vm.parcoursId,
          parcoursName: _vm.$route.parcoursName
        }
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n            Sommaire du parcours\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('translation', {
    attrs: {
      "epigram": _vm.epigram,
      "parcours-title": _vm.parseVersion(_vm.parcours.versions).title,
      "authors": _vm.authors
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('greek-text', {
    attrs: {
      "epigram": _vm.epigram
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-md-offset-1"
  }, [_c('notes', {
    attrs: {
      "notes": _vm.epigram.notes
    }
  }), _vm._v(" "), (_vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-image"
  }, [_c('p', {
    on: {
      "click": _vm.showPopin
    }
  }, [_vm._v("Images du manuscrit")]), _vm._v(" "), _c('ul', _vm._l((_vm.epigram.imagesManuscript), function(img) {
    return _c('li', [_vm._v("\n                  " + _vm._s(img.credit) + "\n                ")])
  }))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.parcours && _vm.parcours.entities) ? _c('pagination', {
    attrs: {
      "total": _vm.parcoursTotal,
      "current": _vm.epigramIndex
    },
    on: {
      "prev": function($event) {
        _vm.prev()
      },
      "next": function($event) {
        _vm.next()
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "component--carousel"
  }, [(_vm.epigram && _vm.epigram.externalRef && _vm.epigram.externalRef.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scroll carousel__container"
  }, [_c('article', {
    staticClass: "carousel__wrapper"
  }, _vm._l((_vm.epigram.externalRef), function(ref, index) {
    return _c('a', {
      staticClass: "carousel__item -link",
      attrs: {
        "href": ref.url,
        "data-src": ref.url,
        "data-caption": ref.title
      },
      on: {
        "click": function($event) {
          _vm.openFancybox(index, $event)
        }
      }
    }, [_vm._v("\n              " + _vm._s(ref.title) + "\n            ")])
  }))])]) : _vm._e()]), _vm._v(" "), (_vm.epigram.imagesManuscript && _vm.epigram.imagesManuscript.length) ? _c('div', {
    staticClass: "manuscript-popin",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.hidePopin,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        return _vm.hidePopin($event)
      }
    }
  }, [_c('div', {
    staticClass: "popin-cross-container",
    on: {
      "click": _vm.hidePopin
    }
  }, [_c('div', {
    staticClass: "popin-cross"
  })]), _vm._v(" "), _vm._l((_vm.epigram.imagesManuscript), function(manuscript) {
    return _c('img', {
      attrs: {
        "src": manuscript.URL,
        "alt": _vm.epigram.title
      }
    })
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notExist"
  }, [_c('p', [_vm._v("L'épigramme que vous cherchez n'existe pas")]), _vm._v(" "), _c('div', {
    staticClass: "inner-links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('span', {
    staticClass: "dash"
  }), _vm._v("\n        Retour à l'accueil\n      ")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "carousel__header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-1"
  }, [_c('div', {
    staticClass: "text-theme"
  }, [_c('h3', [_vm._v("\n                  Références\n                ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3046e6b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParcoursSingleComponent.vue
// module id = 95
// module chunks = 0